module.exports = __webpack_public_path__ + "9dfb536365f2959ccbe336562af4cbe8.png";